var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fmv-drawer',{attrs:{"id":"filters","align":"end"}},[_c('filters-sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }